import {openModalConfirm} from 'js/services/modals'

export default () => (
  openModalConfirm(
    Vue.i18n.t('campaigns.show.automations.workflow.nodes.errorsAlert.title'),
    Vue.i18n.t('campaigns.show.automations.workflow.nodes.errorsAlert.body'),
    Vue.i18n.t('campaigns.show.automations.workflow.nodes.errorsAlert.okButton')
  )
)
